import * as yup from 'yup'

const apiTokenValidationSchema = yup
  .object({
    name: yup.string().trim().required('Name is required').min(3, 'Name should contain at least ${min} characters')
  })
  .required()

export default apiTokenValidationSchema
